import React from "react";
import { Link } from "react-router-dom";
import { PhoneIncoming, Sparkles, UserRoundCog, ArrowRight } from "lucide-react";
import { useI18n } from "../../i18n/I18nContext";

const picks = [
  { idx: 0, Icon: PhoneIncoming, slug: "missed-call-recovery" },
  { idx: 1, Icon: Sparkles, slug: "ai-customer-replies" },
  { idx: 4, Icon: UserRoundCog, slug: "human-takeover" },
];

export const ServicesOverview = () => {
  const { t, lp } = useI18n();
  return (
    <section className="py-12 lg:py-20" data-testid="services-overview">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="mb-8">
          <div className="eyebrow mb-3">{t.nav.services}</div>
          <h2 className="font-display font-bold text-3xl sm:text-4xl text-white tracking-tight">{t.home.servicesGlanceTitle}</h2>
        </div>
        <div className="grid md:grid-cols-3 gap-3">
          {picks.map(({ idx, Icon, slug }) => {
            const s = t.services.list[idx];
            return (
              <div key={slug} className="glass rounded-2xl p-6 flex flex-col" data-testid={`service-overview-${slug}`}>
                <div className="w-11 h-11 rounded-xl bg-blue-600/15 border border-blue-400/30 text-cyan-300 flex items-center justify-center mb-4">
                  <Icon size={18} />
                </div>
                <h3 className="font-display font-bold text-white text-xl">{s.title}</h3>
                <p className="text-slate-400 mt-2 text-sm leading-relaxed line-clamp-2">{s.desc}</p>
                <Link
                  to={lp(`/services#${slug}`)}
                  data-testid={`service-overview-link-${slug}`}
                  className="mt-4 inline-flex items-center gap-1.5 text-cyan-300 hover:text-cyan-200 text-sm font-medium"
                >{t.home.learnMore} <ArrowRight size={13} /></Link>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
